import React from 'react';
import { formatDate } from '../utils/helpers';
import { taskStepSummary } from '../utils/paymentTask';

// The task's completion bar (operator 2026-10-10: "it will be handy if we have a
// completion bar about a particular task, so we know what we have done / what
// haven't been done and should be done in future").
//
// It DRAWS taskSteps() — the one stage model in utils/paymentTask.js — and
// decides nothing itself, so the Task Tracking card, its collapsed row and the
// pool pill can never disagree about where a task is.
//
//   full (default): a stepper — done ✓ green with "who · when", the current
//                   step purple with what happens next (and who · when of any
//                   part already done, e.g. a first slip), the rest grey, a
//                   cancelled / rejected end red with its reason. Stacks
//                   vertically at ≤768px (TaskTracking.css).
//   compact:        one line — "Step 5 of 6 · Order paid" (the step's hint as a
//                   tooltip, or inline with showHint) — for the collapsed row
//                   and the pool card.
export default function TaskProgressBar({ task, compact = false, showHint = false, style }) {
  const summary = taskStepSummary(task);
  if (!summary.steps.length) return null;

  if (compact) {
    return (
      <span
        className={`tpb-compact tpb-compact--${summary.tone}`}
        title={summary.hint || undefined}
        style={style}
      >
        {summary.text}
        {showHint && summary.hint ? <span className="tpb-compact-hint"> — {summary.hint}</span> : null}
      </span>
    );
  }

  return (
    <div className={`tpb tpb--${summary.tone}`} style={style}>
      <div className="tpb-summary">
        <strong>{summary.text}</strong>
        {summary.hint && summary.tone === 'progress' && <span className="tpb-summary-next">Next: {summary.hint}</span>}
      </div>
      <ol className="tpb-steps" aria-label="Task progress">
        {summary.steps.map((st, i) => {
          const meta = [st.who, st.at ? formatDate(st.at) : null].filter(Boolean).join(' · ');
          return (
            <li key={`${st.key}-${i}`} className={`tpb-step tpb-step--${st.state}`} aria-current={st.state === 'current' ? 'step' : undefined}>
              <span className="tpb-dot" aria-hidden="true">
                {st.state === 'done' ? '✓' : st.state === 'cancelled' ? '✕' : i + 1}
              </span>
              <div className="tpb-text">
                <span className="tpb-label">{st.label}</span>
                {st.detail && <span className="tpb-detail">{st.detail}</span>}
                {st.state !== 'todo' && meta && <span className="tpb-meta">{meta}</span>}
                {(st.state === 'current' || st.state === 'cancelled') && st.hint && <span className="tpb-hint">{st.hint}</span>}
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
